import {PlatformMessageType} from "../platform-message-type.enum";

export interface GamblingSessionActionRawData {
    PlatformMessagesType: PlatformMessageType.GAMBLING_SESSION_ACTION,
    MessageDataJson: string;
}

export enum GamblingSessionActionType {
    LossLimitReached = 0,
    TimeLimitReached = 1,
    TimeReminder = 2,
    AdvancedWarningNetLossLimit = 3,
    AdvancedWarningTimeLimit = 4
}


export interface GamblingSessionActionRawItem {
    MessageType: GamblingSessionActionType;
    SessionTotalWins: number;
    SessionTotalBets: number;
    SessionDurationInSeconds: number;
    MessageTimeStamp: string;
    SessionId: string;
    CorrelationID: string;
}
